import React, { useState } from "react";
import { BiSolidFilePdf, BiShow } from "react-icons/bi";
import { FiCheck } from "react-icons/fi";
import { formatDate } from "../../../../utils/dateFormatter";

const CustomAdvocateList = ({
  advocateOpinions,
  selectedOpinionId,
  onChange,
  placeholder = "Select Advocate Opinion"
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Ensure advocateOpinions is always an array
  const opinions = advocateOpinions || [];

  const handleSelect = (opinion) => {
    onChange({
      value: opinion.id,
      label: getOpinionLabel(opinion)
    });
    setIsOpen(false);
  };

  const getOpinionLabel = (opinion, index) => {
    const typeMap = {
      "Legal Opinion": "Legal Opinion",
      "Final Opinion": "Final Opinion"
    };
    
    return typeMap[opinion.type] || opinion.type;
  };

  const getNumberedLabel = (opinion, index) => {
    return `${index + 1}. ${getOpinionLabel(opinion)}`;
  };

  const handleViewDocument = (fileUrl, e) => {
    e.stopPropagation();
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  };

  const selectedOpinion = opinions.find(op => op.id === selectedOpinionId);

  return (
    <div className="relative w-full">
      {/* Selected Value Display */}
      <div
        className="w-full border border-gray-300 rounded-md p-2 cursor-pointer bg-white flex items-center justify-between hover:border-gray-400 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={selectedOpinion ? "text-gray-900" : "text-gray-500"}>
          {selectedOpinion 
            ? `${opinions.findIndex(op => op.id === selectedOpinion.id) + 1}. ${getOpinionLabel(selectedOpinion)}`
            : placeholder
          }
        </span>
        <svg
          className={`w-4 h-4 text-gray-500 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {/* Dropdown Options */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 z-50 mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
          {opinions.length === 0 ? (
            <div className="p-3 text-gray-500 text-sm">No advocate opinions available</div>
          ) : (
            opinions.map((opinion, index) => (
              <div
                key={opinion.id}
                className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 flex items-center justify-between group"
                onClick={() => handleSelect(opinion)}
              >
                <div className="flex items-center space-x-3 flex-1">
                  {/* PDF Icon */}
                  <div className="flex-shrink-0">
                    <BiSolidFilePdf className="text-red-500 text-lg" />
                  </div>
                  
                  {/* Opinion Details */}
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-900 truncate">
                      {getNumberedLabel(opinion, index)}
                    </div>
                    {opinion.createdTimestamp && (
                      <div className="text-xs text-gray-500">
                        Created on {formatDate(opinion.createdTimestamp)}
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex items-center space-x-2 flex-shrink-0">
                  {/* View Document Button */}
                  <button
                    type="button"
                    onClick={(e) => handleViewDocument(opinion.fileUrl, e)}
                    className="p-1 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors"
                    title="View Document"
                  >
                    <BiShow className="text-lg" />
                  </button>
                  
                  {/* Selection Indicator */}
                  {/* {selectedOpinionId === opinion.id && (
                    <div className="p-1 text-green-600">
                      <FiCheck className="text-lg" />
                    </div>
                  )} */}
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Overlay to close dropdown when clicking outside */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsOpen(false)}
        />
      )}


      

    </div>
  );
};

export default CustomAdvocateList;